import { useTranslation } from "react-i18next";
import { HiDesktopComputer } from "react-icons/hi";

interface DesktopViewRequiredMessageProps {
  titleKey?: string;

  descriptionKey?: string;

  className?: string;

  icon?: React.ReactNode;
}

export function DesktopViewRequiredMessage({
  titleKey = "common.desktopRequired",
  descriptionKey = "common.desktopRequiredDescription",
  className = "",
  icon,
}: DesktopViewRequiredMessageProps) {
  const { t } = useTranslation();

  const defaultIcon = (
    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
      <HiDesktopComputer className="w-8 h-8 text-blue-600" />
    </div>
  );

  return (
    <div className={`block md:hidden w-full px-4 py-8 ${className}`}>
      <div className="bg-blue-50 rounded-xl p-6 border border-blue-100 shadow-lg">
        <div className="flex flex-col items-center text-center gap-4">
          {icon || defaultIcon}
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">
              {t(titleKey)}
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              {t(descriptionKey)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
